import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef, GridToolbar } from '@mui/x-data-grid-pro';
import { parseISO } from 'date-fns';
import React from 'react';

import { FScoreMetric } from 'app/model/redshift/f-score-metric';

export const FScoreReportGrid: React.FunctionComponent<Omit<DataGridProProps<FScoreMetric>, 'columns'>> = ({
    ...rest
}) => (
    <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
        <DataGridPro components={{ Toolbar: GridToolbar }} {...rest} columns={commonColumns} />
    </Box>
);

const commonColumns: Array<GridColDef<FScoreMetric>> = [
    {
        field: 'id',
        headerName: 'ID',
        type: 'number',
    },
    {
        field: 'storeId',
        headerName: 'Store Id',
        type: 'number',
    },
    {
        field: 'storeName',
        headerName: 'Store Name',
        type: 'string',
    },
    {
        field: 'tpTrans',
        headerName: 'TP Trans',
        type: 'number',
    },
    {
        field: 'tpSpend',
        headerName: 'TP Spend',
        type: 'number',
    },
    {
        field: 'fpTrans',
        headerName: 'FP Trans',
        type: 'number',
    },
    {
        field: 'fpSpend',
        headerName: 'FP Spend',
        type: 'number',
    },
    {
        field: 'fnTrans',
        headerName: 'TP Trans',
        type: 'number',
    },
    {
        field: 'fnSpend',
        headerName: 'TP Spend',
        type: 'number',
    },
    {
        field: 'precision',
        headerName: 'Precision',
        type: 'number',
    },
    {
        field: 'recall',
        headerName: 'Recall',
        type: 'number',
    },
    {
        field: 'fscore',
        headerName: 'F-Score',
        type: 'number',
    },
    {
        field: 'dateAdded',
        headerName: 'Date Added',
        type: 'date',
        valueFormatter: (params) => (params.value ? parseISO(params.value as string).toLocaleDateString() : ''),
    },
];
